export var RoleEnum = {
    AGENCY_WORKER: "AgencyWorker",
    COLLECTIONS_ADMINISTRATOR: "CollectionsAdministrator",
    DISTRIBUTOR: "Distributor",
    LOGGED_USER: "LoggedUser",
    ONIX_CODETABLES_ADMINISTRATOR: "OnixCodetablesAdministrator",
    PUBLISHER_ADMIN: "PublisherAdmin",
    PUBLISHER_GUARANTOR: "PublisherGuarantor",
    PUBLISHER_SYSTEM: "PublisherSystem",
    SUPERUSER: "Superuser",
    SYSTEM: "System",
};
export var RoleGroups = {
    PUBLISHER_ROLES: [RoleEnum.PUBLISHER_GUARANTOR, RoleEnum.PUBLISHER_ADMIN],
    /** Roles allowed to create and edit collections (Řady). */
    COLLECTION_EDITOR_ROLES: [
        RoleEnum.AGENCY_WORKER,
        RoleEnum.PUBLISHER_GUARANTOR,
        RoleEnum.PUBLISHER_ADMIN,
        RoleEnum.COLLECTIONS_ADMINISTRATOR,
    ],
};
